interface ContactProps {
  onOpenModal: () => void;
}

export default function Contact({ onOpenModal }: ContactProps) {
  return (
    <section id="contact" className="bg-white">
      {/* Hero Image Break with Quote */}
      <div className="relative h-[400px] w-full overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/37524be35dfe83925cad70d6943a1c8e.jpg"
          alt="Framing Studio"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Contact Content */}
      <div className="py-28 bg-[#FDFCFA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Left Column - Intro */}
            <div>
              <div className="inline-block mb-6 px-5 py-2 border border-[#D4B137] rounded-full">
                <p className="text-black text-xs font-semibold tracking-widest uppercase">Get In Touch</p>
              </div>
              <h3 className="text-3xl md:text-5xl font-serif font-bold text-black mb-6 leading-tight">
                Visit Our Sherman Oaks Studio
              </h3>
              <p className="text-black/70 text-base md:text-lg mb-10 leading-relaxed">
                Experience 39 years of framing artistry. Schedule a consultation to discuss your project and explore our extensive selection of frames and
                materials.
              </p>

              <div className="flex flex-wrap gap-4">
                <button
                  onClick={onOpenModal}
                  className="inline-flex items-center gap-2 px-8 py-4 bg-[#D4B137] text-black text-sm font-semibold rounded-full hover:bg-[#C4A127] transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-calendar-line"></i>
                  Book a Consultation
                </button>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=14005+Ventura+Blvd+Sherman+Oaks+CA+91423"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-8 py-4 bg-black text-white text-sm font-semibold rounded-full hover:bg-black/85 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-map-pin-line"></i>
                  Get Directions
                  <i className="ri-arrow-right-up-line"></i>
                </a>
              </div>
            </div>

            {/* Right Column - Contact Details */}
            <div className="space-y-8">
              <div className="flex items-start gap-4 md:gap-5">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full border border-[#D4B137]/30 bg-white shadow-sm">
                  <i className="ri-phone-line text-lg md:text-xl text-[#D4B137]"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-black mb-1 text-base md:text-lg">Phone</h4>
                  <a href="tel:8187835274" className="text-lg md:text-xl font-medium text-black hover:text-[#D4B137] transition-colors cursor-pointer">
                    (818) 783-5274
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 md:gap-5">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full border border-[#D4B137]/30 bg-white shadow-sm">
                  <i className="ri-mail-line text-lg md:text-xl text-[#D4B137]"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-black mb-1 text-base md:text-lg">Email</h4>
                  <a href="mailto:flashframers@yahoo.com" className="text-lg md:text-xl font-medium text-black hover:text-[#D4B137] transition-colors cursor-pointer">
                    flashframers@yahoo.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 md:gap-5">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full border border-[#D4B137]/30 bg-white shadow-sm">
                  <i className="ri-map-pin-line text-lg md:text-xl text-[#D4B137]"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-black mb-1 text-base md:text-lg">Location</h4>
                  <p className="text-black/70 text-sm md:text-base">14005 Ventura Blvd</p>
                  <p className="text-black/70 text-sm md:text-base">Sherman Oaks, CA 91423</p>
                </div>
              </div>

              <div className="flex items-start gap-4 md:gap-5">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full border border-[#D4B137]/30 bg-white shadow-sm">
                  <i className="ri-time-line text-lg md:text-xl text-[#D4B137]"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-black mb-1 text-base md:text-lg">Hours</h4>
                  <div className="space-y-1">
                    <p className="text-black/70 text-sm md:text-base">Mon: Closed</p>
                    <p className="text-black/70 text-sm md:text-base">Tue - Fri: 10:00 AM - 5:00 PM</p>
                    <p className="text-black/70 text-sm md:text-base">Sat: 11:00 AM - 5:00 PM</p>
                    <p className="text-black/70 text-sm md:text-base">Sun: By Appointment Only</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
